var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('out-put-page',{staticClass:"landscape",attrs:{"title":"Étude financière","sectionRef":"charges_externes_c_a","orientation":"landscape"},on:{"page-updated":_vm.handleAfterRender}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }